'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _currencyConversions = require('./remote/currencyConversions');

var CurrencyConversions = {
    fetchCurrencyConversions: _currencyConversions.CurrencyConversionsRemote.fetchCurrencyConversions
};

exports.default = CurrencyConversions;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/currencyConversions.js
// module id = Jfhc
// module chunks = 60